import React from 'react';
import classnames from "classnames"
import {Modal, ModalHeader, ModalBody, ModalFooter, Col, Row} from 'reactstrap';
import FormHelper from '../form.js';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import ModalSelectInMap from '../../../../utils/Modal/ModalSelectInMap.js';
import Module from '../../../../utils/Render.js';
import PhoneInput from 'react-phone-number-input'
import SelectQuery from '../../../../component/SelectQuery.js'; 

export default class ModalUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alias    : props.data.alias,
      username : props.data.username,
      password : props.data.password,
      re_password: "",
      firstname: props.data.firstname,
      lastname : props.data.lastname,
      email    : props.data.email,
      phone    : props.data.phone,
      address  : props.data.address,
      address2 : props.data.address2,
      city     : props.data.city,
      postal   : props.data.postal,
      next_of_kin: props.data.next_of_kin,
      phone_next_of_kin: props.data.phone_next_of_kin,
      tag      : props.data.tag,
      role     : props.data.role,
      is_active: props.data.is_active,
      modalMap : false,
      toggle_tab: props.toggle_tab,
    }

    this.modalAction               = this.modalAction.bind(this)
    this.modalActionUpdatePassword = this.modalActionUpdatePassword.bind(this)
    this.toggleModalSelectInMap    = this.toggleModalSelectInMap.bind(this)
  }

  // Get Data from google map
  toggleModalSelectInMap(){
    this.setState({ modalMap : !this.state.modalMap })
  }

  getMapLocation(data){
    this.setState({
      address   : data.address,
      address2  : data.address2,
      postal    : data.postal,
    })
  }

  handleCheckboxChange(event) {
    this.setState({
      is_active : event.target.checked,
    })
  }

  modalAction() {
    const {mode, register, update} = this.props

    if(!FormHelper.ValidateForm(this.state, this.props.mode)) {
      return
    }

    if(mode === "modal_add") {
      let data = {
        username : this.state.username,
        password : this.state.password,
        firstname: this.state.firstname,
        lastname : this.state.lastname,
        email    : this.state.email,
        phone    : this.state.phone,
        address  : this.state.address,
        address2 : this.state.address2,
        city     : this.state.city,
        postal   : this.state.postal,
        next_of_kin: this.state.next_of_kin,
        phone_next_of_kin: this.state.phone_next_of_kin,
        tag      : this.state.tag,
        role     : this.state.role,
        is_active: this.state.is_active,
      }
      register(data);
    } else {
      let data = {
        alias    : this.state.alias,
        username : this.state.username,
        firstname: this.state.firstname,
        lastname : this.state.lastname,
        email    : this.state.email,
        phone    : this.state.phone,
        address  : this.state.address,
        address2 : this.state.address2,
        city     : this.state.city,
        postal   : this.state.postal,
        next_of_kin: this.state.next_of_kin,
        phone_next_of_kin: this.state.phone_next_of_kin,
        tag      : this.state.tag,
        role     : this.state.role,
        is_active: this.state.is_active,
      }
      update(data);
    }
  }

  modalActionUpdatePassword() {
    if(!FormHelper.ValidateUpdatePasswordForm(this.state)) {
      return
    }

    let data = {
      alias    : this.state.alias,
      password : this.state.password
    }
    this.props.updatePass(data)
  }

  componentDidUpdate(prevProps) {
    let new_state = {}

    if(this.props.isModal !== prevProps.isModal) {
      if(this.props.mode === "modal_update") {
        new_state = {
          alias    : this.props.data.alias,
          username : this.props.data.username,
          firstname: this.props.data.firstname,
          lastname : this.props.data.lastname,
          email    : this.props.data.email,
          phone    : this.props.data.phone,
          address  : this.props.data.address,
          address2 : this.props.data.address2,
          city     : this.props.data.city === null ? "" : this.props.data.city.pk,
          postal   : this.props.data.postal,
          next_of_kin: this.props.data.next_of_kin,
          phone_next_of_kin: this.props.data.phone_next_of_kin,
          tag      : this.props.data.tag,
          role     : this.props.data.role === null ? "" : this.props.data.role.Alias,
          is_active: this.props.data.is_active,
        }

      } else{
        new_state = {
          alias    : "",
          username : "",
          password : "",
          re_password: "",
          firstname: "",
          lastname : "",
          email    : "",
          phone    : "",
          address  : "",
          address2 : "",
          city     : "",
          postal   : "",
          next_of_kin: "",
          phone_next_of_kin: "",
          tag      : "",
          role     : "",
          is_active: "",
        }
      }
      this.setState(new_state)
    }
  }

  renderBody() {
    const {mode, toggle_tab} = this.props
    if(toggle_tab === "user") {
      return(
        <Row>
          <div className={classnames("form-group", {"col-sm-10": mode === "modal_update"}, {"col-sm-12": mode === "modal_add"})}>
            <label className="required">User Name</label>
            <input
              disabled = {mode === "modal_update"}
              type="text"
              className="form-control"
              placeholder="Type User Name"
              value={this.state.username}
              onChange={(e) => this.setState({username: e.target.value})}
            />
          </div>
          {mode === "modal_add" &&
            <div className={classnames("form-group col-sm-6", {"form-group col-sm-6": mode === "modal_add"})}>
              <label className="required">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Type Password"
                onChange={(e) => this.setState({password: e.target.value})}
              />
            </div>
          }
          {mode === "modal_add" &&
            <div className={classnames("form-group col-sm-6", {"form-group col-sm-6": mode === "modal_add"})}>
              <label className="required">Re-Enter Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Type Password"
                onChange={(e) => this.setState({re_password: e.target.value})}
              />
            </div>
          }
          {mode === "modal_update" &&
            <Col sm="2" className="form-group">
              <label className="required">Active</label>
              <label className="switch switch-lg switch-text switch-primary mb0">
                <input
                  onChange={(event)=>this.handleCheckboxChange(event)}
                  type="checkbox"
                  className="switch-input"
                  checked={this.state.is_active}
                />
                <span className="switch-label" data-on="On" data-off="Off"></span>
                <span className="switch-handle"></span>
              </label>
            </Col>
          }
          <Col sm="6" className="form-group">
            <label className="required">First Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type First Name"
              value={this.state.firstname}
              onChange={(e) => this.setState({firstname: e.target.value})}
            />
          </Col>
          <Col sm="6" className="form-group">
            <label className="required">Last Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Last Name"
              value={this.state.lastname}
              onChange={(e) => this.setState({lastname: e.target.value})}
            />
          </Col>
          <Col sm="6" className="form-group">
            <label className="required">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Type Email"
              value={this.state.email}
              onChange={(e) => this.setState({email: e.target.value})}
            />
          </Col>
          <Col sm="6" className="form-group">
            <label className="required">Phone number</label>
            <PhoneInput
              className="form-control"
              placeholder="Enter phone number"
              value={ this.state.phone }
              onChange={ phone => this.setState({ phone }) }
            />
          </Col>
          <div className="form-group col-sm-6">
            {Module.SelectInMapButton(this.toggleModalSelectInMap)}
            <label className="required">Address</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Address"
              value={this.state.address}
              onChange={(e) => this.setState({address: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">Address 2</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Address 2"
              value={this.state.address2}
              onChange={(e) => this.setState({address2: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">City</label>
            <SelectQuery
              placeholder="Type City"
              value={this.state.city}
              onChange={(val) => this.setState({city: val.pk})}
              urlKey="read-city-in-cov-autocomplete"
              valKey="pk"
              valLabel="Name"
              initOption={this.props.data.city}
              isCreatable={false}
              UserReducer={this.props.UserReducer}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">Postal</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Postal Code"
              value={this.state.postal}
              onChange={(e) => this.setState({postal: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="optional">Next of kins</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Next of kins"
              value={this.state.next_of_kin}
              onChange={(e) => this.setState({next_of_kin: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="optional">Phone Number</label>
            <PhoneInput
              className="form-control"
              placeholder="Enter phone number"
              value={ this.state.phone_next_of_kin }
              onChange={ phone_next_of_kin => this.setState({ phone_next_of_kin }) }
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="optional">Tag</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type Tag"
              value={this.state.tag}
              onChange={(e) => this.setState({tag: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">Role</label>
            <SelectQuery
              placeholder="Type Role"
              value={this.state.role}
              onChange={(val) => this.setState({role: val.Alias})}
              urlKey="read-role-autocomplete"
              valKey="Alias"
              valLabel="Name"
              initOption={this.props.data.role}
              isCreatable={false}
              UserReducer={this.props.UserReducer}
            />
          </div>
        </Row>
      )
    } else {
      return (
        <Row>
          <div className="form-group col-sm-12">
            <label className="required">User Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              value={this.state.username}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Type New Password"
              onChange={(e) => this.setState({password: e.target.value})}
            />
          </div>
          <div className="form-group col-sm-6">
            <label className="required">Re-enter Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Type New Password"
              onChange={(e) => this.setState({re_password: e.target.value})}
            />
          </div>
        </Row>
      )
    }
  }

  renderFooter() {
    const {close, mode, is_process, toggle_tab} = this.props
    if(toggle_tab === "user") {
      return (
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={this.modalAction}>
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
        </ModalFooter>
      )
    } else {
      return (
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={this.modalActionUpdatePassword}>Update Password</ButtonValidation>
        </ModalFooter>
      )
    }

  }

  render() {
    const {isModal, close, mode, toggle_tab, toggleTab} = this.props

    return (
      <Modal isOpen={isModal} toggle={close} className="modal-lg" backdrop="static">
        <ModalHeader className="mh-full-width">
          <a onClick={()=>toggleTab("user")} className={classnames({"mh-deactive" : toggle_tab !== "user"})} role="button">{mode === "modal_add" ? 'Add new' : 'Update'} User</a>
          {mode === "modal_update" &&
            <a onClick={()=>toggleTab("pass")} className={classnames("float-right", {"mh-deactive" : toggle_tab !== "pass"})} role="button">Update Password</a>
          }
        </ModalHeader>

        <ModalBody>
          {this.renderBody()}
        </ModalBody>
        {this.renderFooter()}

        <ModalSelectInMap
          defaultLocation = {{
            'latitude'  : -43.525650,
            'longitude' : 172.639847
          }}
          onSave          = {this.getMapLocation.bind(this)}
          isOpen          = {this.state.modalMap}
          closeModal      = {this.toggleModalSelectInMap}
        />

      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/user/helper/component/Modal.js